let id = 0;
export const getNextID = () => {
    id += 1;
    if (id === Number.MAX_SAFE_INTEGER) {
        id = 0;
    }
    return id;
};

//# sourceMappingURL=referenceCounter.js.map
